import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inviterUserFilter'
})
export class inviterUser implements PipeTransform {
    transform(items: any[], boardSearch: string | number): any[] {    
        if (!items) return [];
        if (!boardSearch) return items;
    
        const searchLower = boardSearch.toString().toLowerCase();
    
        return items.filter(item => {
            const { username, name, email } = item;
    
            // Combine all fields into a single string for search
            const combinedFields = `${username} ${name} ${email}`.toLowerCase();
    
            return combinedFields.includes(searchLower);
        });
    }
    }
    